import { render } from "./CategoryMultiSelect.vue?vue&type=template&id=2195a2fe&ts=true"
import script from "./CategoryMultiSelect.vue?vue&type=script&lang=ts"
export * from "./CategoryMultiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__